var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"delete-icon",staticStyle:{"cursor":"pointer"},on:{"click":_vm.onIconClicked}},[_c('div',{staticClass:"icon-container"},[_vm._v(" Xóa ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }